import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
    palette: {
        mode: "dark",
        primary: {
            main: "#00bcd4",
            light: "#62efff",
            dark: "#008ba3",
        },
        secondary: {
            main: "#ff4081",
            light: "#ff79b0",
            dark: "#c60055",
        },
        background: {
            default: "#0a0a0a",
            paper: "#1a1a1a",
        },
        text: {
            primary: "#ffffff",
            secondary: "#b0b0b0",
        },
        divider: "#333333",
    },
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        h1: {
            fontSize: "2.5rem",
            fontWeight: 600,
        },
        h2: {
            fontSize: "2rem",
            fontWeight: 600,
        },
        h3: {
            fontSize: "1.75rem",
            fontWeight: 600,
        },
        h4: {
            fontSize: "1.5rem",
            fontWeight: 600,
        },
        h5: {
            fontSize: "1.25rem",
            fontWeight: 600,
        },
        h6: {
            fontSize: "1rem",
            fontWeight: 600,
        },
    },
    components: {
        MuiCard: {
            styleOverrides: {
                root: {
                    backgroundImage: "none",
                    backgroundColor: "#1a1a1a",
                    border: "1px solid #333333",
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: "none",
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: "none",
                    borderRadius: 8,
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                            borderColor: "#333333",
                        },
                        "&:hover fieldset": {
                            borderColor: "#00bcd4",
                        },
                        "&.Mui-focused fieldset": {
                            borderColor: "#00bcd4",
                        },
                    },
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundImage: "none",
                    backgroundColor: "#1a1a1a",
                    borderBottom: "1px solid #333333",
                },
            },
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: "#1a1a1a",
                    borderRight: "1px solid #333333",
                },
            },
        },
        MuiListItem: {
            styleOverrides: {
                root: {
                    "&.Mui-selected": {
                        backgroundColor: "rgba(0, 188, 212, 0.1)",
                        "&:hover": {
                            backgroundColor: "rgba(0, 188, 212, 0.2)",
                        },
                    },
                },
            },
        },
    },
});
